import { commonOptionPropTypes, } from '../GenericOption/GenericOption.types';
export const checkboxPropTypes = commonOptionPropTypes;
//# sourceMappingURL=Checkbox.types.js.map